"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _class = _interopRequireDefault(require("../class"));

var _seemple = _interopRequireDefault(require("../seemple"));

var _prototype = _interopRequireDefault(require("./_prototype"));

var _seempleerror = _interopRequireDefault(require("../_helpers/seempleerror"));

var _init = _interopRequireDefault(require("../_core/init"));

var _staticmembers = _interopRequireDefault(require("./_staticmembers"));

_prototype["default"]["extends"] = _seemple["default"];

_prototype["default"].constructor = function SeempleArray(length) {
  if (!(this instanceof SeempleArray)) {
    throw (0, _seempleerror["default"])('common:call_class');
  }

  (0, _init["default"])(this); // repeat the same logic as for native Array

  if (arguments.length === 1 && typeof length === 'number') {
    this.length = length;
  } else if (arguments.length) {
    this.recreate(arguments, {
      silent: true,
      dontRender: true
    });
  } // return is used to make possible to chain super() calls


  return this;
};

var SeempleArray = (0, _class["default"])(_prototype["default"], _staticmembers["default"]);
var _default = SeempleArray;
exports["default"] = _default;
//# sourceMappingURL=index.js.map